import React from 'react';
import AvailabilityCalendar from './components/AvailabilityCalendar';

function App() {
  return (
    <div className="App">
      <AvailabilityCalendar />
    </div>
  );
}

export default App;